import React, { useState, useRef, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import { API } from "../../../../Services/api-services";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import { makeStyles } from "@material-ui/core/styles";
import PaymentDeferralOnBreakErrorModal from "../../PaymentDetails/PaymentDeferralOnBreakErrorModal.jsx";
import StudentBreakReponseModal from "../../PaymentDetails/StudentBreakResponseModal";

import { Form } from "react-bootstrap";
import moment from "moment";
import StudentLeaveDescription from "./StudentLeaveDescription/index.jsx";
import orange_warning from "../../../../assets/images/orange_warning.svg";
import blue_warning from "../../../../assets/images/blue_warning.svg";
import ActionButtons from "../../../StudentPause/ActionButtons/index.jsx";

toast.configure();
const useStyles = makeStyles((theme) => ({
  changeDateBox: {
    width: "299px",
    height: "60px",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
  },
  label: {
    fontSize: "16px",
    fontWeight: "400",
    fontFamily: "Roboto",
    color: "#555555",
    width: "100%",
    textAlign: "center",
  },
  formLabel: {
    fontFamily: "Roboto",
    fontWeight: "400",
    fontSize: "16px",
    color: "#292929",
  },
  datePicker: {
    margin: "-27px 0 0 120px",
    color: "#0059B8",
    border: "#0059B8",
    borderBottom: "1px solid #0059B8",
    "&:focus": {
      border: "none",
      color: "#0059B8",
    },
  },
  classesAffectedWrapper: {
    width: "48%",
    marginTop: "24px",
  },
  availableDetailConatainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "10px",
    gap: "20px",
  },
  availableDetail: {
    height: "35px",
    borderRadius: "4px",
    padding: "8px 12px",
    backgroundColor: "#F0F0F0",
    display: "flex",
    flex: 0.5,
  },
  label: {
    fontSize: "16px",
    fontWeight: "400",
    fontFamily: "Roboto",
    color: "#555555",
    width: "100%",
    textAlign: "center",
  },
  font600: {
    fontWeight: "600",
  },
  customScroll: {
    overflowY: "auto",
    scrollbarWidth: "thin", // Firefox
    scrollbarColor: "#888 transparent",

    /* WebKit (Chrome, Safari) */
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#888",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
  },
}));

const StudentLeave = ({
  open,
  closeModalHandler,
  batchId,
  students,
  orderId,
  fromHome = false,
}) => {
  const classes = useStyles();
  /*
 leaveType: 0 => multiple leave
 leaveType: 1 => single leaves
 leaveType: 2 => on break
 */
  const type = fromHome ? 2 : 1;
  const [leaveType, setLeaveType] = useState(type);
  const [leaveStartDate, setLeaveStartDate] = useState(null);
  const [leaveEndDate, setLeaveEndDate] = useState(null);
  const startDateForWhichDataFetched = useRef(null);
  const endDateForWhichDataFetched = useRef(null);
  const wasSingleDateLeaveForWhichDataFetched = useRef(null);
  const [classesAffected, setClassesAffected] = useState(null);
  const [loader, setLoader] = useState(false);
  const [breakReason, setBreakReason] = useState("");
  const [countAsCancellation, setCountAsCancellation] = useState(true);
  const [isCountAsCancelChanged, setIsCountAsCancelChanged] = useState(false);
  const [deferralErrorModal, setDeferralErrorModal] = useState(false);
  const [deferralErrorMsg, setDeferralErrorMsg] = useState(
    "Deferral cannot be done for this student"
  );
  const [responseModal, setResponseModal] = useState(false);
  const [deferPayment, setDeferPayment] = useState(false);
  const [newDate, setNewDate] = useState(null);
  const [responseLeaveStart, setResponseLeaveStart] = useState(leaveEndDate);
  const [responseLeaveEnd, setResponseLeaveEnd] = useState(null);
  const [showUsedPauseMessage, setShowUsedPauseMessage] = useState(false);
  const [showCancelExceedMessage, setShowCancelExceedMessage] = useState(false);
  const [pauseAndCancellationData, setPauseAndCancellationData] = useState({});
  const [pauseAndCancellationUsedData, setPauseAndCancellationUsedData] =
    useState({});

  const dateChangeHandlerForDeferPayment = (e) => {
    setNewDate(e.target.value);
  };

  const [paymentMode, setPaymentMode] = useState("");
  const [paymentGateway, setPaymentGateway] = useState();
  const [nextPaymentDate, setNextPaymentDate] = useState("");

  let hasDateChangedAfterFetching =
    !startDateForWhichDataFetched || // this attrib being a falsy, shows that no data was fetched yet
    startDateForWhichDataFetched.current !== leaveStartDate ||
    endDateForWhichDataFetched.current !== leaveEndDate ||
    wasSingleDateLeaveForWhichDataFetched.current !== leaveType;
  const dateChangeHandler = (e, isStartDate) => {
    if (isStartDate) {
      setLeaveStartDate(e.target.value);
    } else {
      setLeaveEndDate(e.target.value);
    }
    if (hasDateChangedAfterFetching) {
      setClassesAffected(null);
      hasDateChangedAfterFetching = true;
    }
  };

  var newPaypalDate;
  if (paymentGateway === "paypal") {
    let paymentDueDate = Number(moment(nextPaymentDate).format("DD"));
    let paymentDueMonth = Number(moment(nextPaymentDate).format("MM"));
    let paymentDueYear = Number(moment(nextPaymentDate).format("YYYY"));
    let newPaymentDate = Number(moment(newDate).format("DD"));
    let newPaymentMonth = Number(moment(newDate).format("MM"));
    let newPaymentYear = Number(moment(newDate).format("YYYY"));
    if (
      paymentDueMonth === newPaymentMonth &&
      paymentDueYear === newPaymentYear &&
      newPaymentDate > paymentDueDate &&
      newPaymentMonth < 12
    ) {
      newPaymentMonth += 1;
      if (newPaymentMonth < 10) {
        newPaymentMonth = newPaymentMonth.toString();
        newPaymentMonth = "0" + newPaymentMonth;
      }
      newPaypalDate = `${paymentDueYear}-${newPaymentMonth}-${paymentDueDate}`;
    } else if (
      paymentDueMonth < newPaymentMonth &&
      paymentDueYear === newPaymentYear &&
      newPaymentDate <= paymentDueDate &&
      newPaymentMonth <= 12
    ) {
      if (newPaymentMonth < 10) {
        newPaymentMonth = newPaymentMonth.toString();
        newPaymentMonth = "0" + newPaymentMonth;
      }
      newPaypalDate = `${paymentDueYear}-${newPaymentMonth}-${paymentDueDate}`;
    } else if (
      paymentDueMonth === newPaymentMonth &&
      paymentDueYear < newPaymentYear &&
      newPaymentDate > paymentDueDate &&
      newPaymentMonth < 12
    ) {
      newPaymentMonth += 1;
      if (newPaymentMonth < 10) {
        newPaymentMonth = newPaymentMonth.toString();
        newPaymentMonth = "0" + newPaymentMonth;
      }
      newPaypalDate = `${newPaymentYear}-${newPaymentMonth}-${paymentDueDate}`;
    } else if (
      paymentDueMonth < newPaymentMonth &&
      paymentDueYear < newPaymentYear &&
      newPaymentDate > paymentDueDate &&
      newPaymentMonth < 12
    ) {
      newPaymentMonth += 1;
      if (newPaymentMonth < 10) {
        newPaymentMonth = newPaymentMonth.toString();
        newPaymentMonth = "0" + newPaymentMonth;
      }
      newPaypalDate = `${newPaymentYear}-${newPaymentMonth}-${paymentDueDate}`;
    } else if (
      paymentDueMonth === newPaymentMonth &&
      paymentDueYear < newPaymentYear &&
      newPaymentDate <= paymentDueDate &&
      newPaymentMonth < 12
    ) {
      if (newPaymentMonth < 10) {
        newPaymentMonth = newPaymentMonth.toString();
        newPaymentMonth = "0" + newPaymentMonth;
      }
      newPaypalDate = `${newPaymentYear}-${newPaymentMonth}-${paymentDueDate}`;
    } else if (
      paymentDueMonth < newPaymentMonth &&
      paymentDueYear < newPaymentYear &&
      newPaymentDate <= paymentDueDate &&
      newPaymentMonth <= 12
    ) {
      if (newPaymentMonth < 10) {
        newPaymentMonth = newPaymentMonth.toString();
        newPaymentMonth = "0" + newPaymentMonth;
      }
      newPaypalDate = `${newPaymentYear}-${newPaymentMonth}-${paymentDueDate}`;
    } else if (
      paymentDueMonth < newPaymentMonth &&
      paymentDueYear === newPaymentYear &&
      newPaymentDate > paymentDueDate &&
      newPaymentMonth < 12
    ) {
      newPaymentMonth += 1;
      if (newPaymentMonth < 10) {
        newPaymentMonth = newPaymentMonth.toString();
        newPaymentMonth = "0" + newPaymentMonth;
      }
      newPaypalDate = `${paymentDueYear}-${newPaymentMonth}-${paymentDueDate}`;
    } else if (
      paymentDueMonth < newPaymentMonth &&
      paymentDueYear === newPaymentYear &&
      newPaymentDate > paymentDueDate &&
      newPaymentMonth === 12
    ) {
      newPaymentYear += 1;
      newPaymentMonth = newPaymentMonth - 11;
      if (newPaymentMonth < 10) {
        newPaymentMonth = newPaymentMonth.toString();
        newPaymentMonth = "0" + newPaymentMonth;
      }
      newPaypalDate = `${newPaymentYear}-${newPaymentMonth}-${paymentDueDate}`;
    } else if (
      paymentDueMonth < newPaymentMonth &&
      paymentDueYear < newPaymentYear &&
      newPaymentDate <= paymentDueDate &&
      newPaymentMonth === 12
    ) {
      if (newPaymentMonth < 10) {
        newPaymentMonth = newPaymentMonth.toString();
        newPaymentMonth = "0" + newPaymentMonth;
      }
      newPaypalDate = `${newPaymentYear}-${newPaymentMonth}-${paymentDueDate}`;
    } else if (
      paymentDueMonth < newPaymentMonth &&
      paymentDueYear < newPaymentYear &&
      newPaymentDate > paymentDueDate &&
      newPaymentMonth === 12
    ) {
      newPaymentYear += 1;
      newPaymentMonth = newPaymentMonth - 11;
      if (newPaymentMonth < 10) {
        newPaymentMonth = newPaymentMonth.toString();
        newPaymentMonth = "0" + newPaymentMonth;
      }
      newPaypalDate = `${newPaymentYear}-${newPaymentMonth}-${paymentDueDate}`;
    } else if (
      paymentDueMonth > newPaymentMonth &&
      paymentDueYear < newPaymentYear &&
      newPaymentDate <= paymentDueDate &&
      newPaymentMonth <= 12
    ) {
      if (newPaymentMonth < 10) {
        newPaymentMonth = newPaymentMonth.toString();
        newPaymentMonth = "0" + newPaymentMonth;
      }
      newPaypalDate = `${newPaymentYear}-${newPaymentMonth}-${paymentDueDate}`;
    } else if (
      paymentDueMonth > newPaymentMonth &&
      paymentDueYear < newPaymentYear &&
      newPaymentDate > paymentDueDate &&
      newPaymentMonth <= 12
    ) {
      newPaymentMonth += 1;
      if (newPaymentMonth < 10) {
        newPaymentMonth = newPaymentMonth.toString();
        newPaymentMonth = "0" + newPaymentMonth;
      }
      newPaypalDate = `${newPaymentYear}-${newPaymentMonth}-${paymentDueDate}`;
    }
  }

  const fetchPauseAndCancellationDetails = async () => {
    try {
      setLoader(true);
      const response = await API.get(
        `/student/pause/limits/${students[0].studentId}`
      );
      setPauseAndCancellationData(response?.data);
    } catch (err) {
      console.error("Error while fetching pause and cancellation details", err);
    } finally {
      setLoader(false);
    }
  };

  const calculateCancellationAndPause = async () => {
    try {
      setLoader(true);
      const response = await API.get(
        `/student/pause/calculate-cancellations/${students[0].studentId}`,
        {
          pauseStartDate: leaveStartDate,
          pauseEndDate: leaveEndDate,
          countAsCancellation: countAsCancellation ? 1 : 0,
        }
      );
      setPauseAndCancellationUsedData(response?.data);
      setShowUsedPauseMessage(true);
      response?.data?.numberOfCancellationsOverLimit > 0
        ? setShowCancelExceedMessage(true)
        : setShowCancelExceedMessage(false);
    } catch (err) {
      console.error("Error while fetching pause and cancellation details", err);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    setLoader(true);
    API.get("/get/payment-info", {
      studentId: students[0].studentId,
      orderId,
    })
      .then((res) => {
        if (res.data.status === true) {
          let total = 0;
          let collectedAmount = 0;
          let pendingAmount = 0;
          let paymentSource = "";
          let nextDate = "";
          res.data.paymentDetailsList.rows.map((payment) => {
            total += +payment.amount;
            paymentSource = payment.vendor;
            if (payment.paymentStatus === 0) {
              nextDate = payment.deadlineDate;
            }
            if (payment.paymentStatus) {
              collectedAmount += +payment.amount;
            } else {
              pendingAmount += +payment.amount;
            }
          });
          setNextPaymentDate(nextDate);
          setPaymentGateway(paymentSource);
          setPaymentMode(res.data?.modeOfPayment);

          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((e) => {
        console.error("Error ", e);
      });

    fetchPauseAndCancellationDetails();
  }, []);

  const applyLeave = async () => {
    setLoader(true);
    try {
      const body = {
        studentId: students[0].studentId,
        pauseStartDate: leaveStartDate,
        pauseEndDate: leaveEndDate,
        countAsCancellation: countAsCancellation ? 1 : 0,
        pauseReason: breakReason,
      };
      const response = await API.post("student/pause", body);
      setResponseLeaveStart(leaveStartDate);
      setResponseLeaveEnd(leaveEndDate);
      setResponseModal(true);
      setLoader(false);
    } catch (err) {
      setLoader(false);
      if (err?.response?.data?.msg) {
        toast.error(err.response.data.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error("Something went wrong", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  };
  const applyDeferralPayment = () => {
    setLoader(true);
    if (
      paymentMode === "subscription" &&
      (paymentGateway === "stripe" ||
        paymentGateway === "paypal" ||
        paymentGateway === "payglocal" ||
        paymentGateway === "razorpay" ||
        paymentGateway === "xPay")
    ) {
      API.post(`/deferral`, {
        orderId: orderId,
        pushedBy: newDate,
        paymentService: paymentGateway,
        newStartDatePaypal: paymentGateway === "paypal" ? newPaypalDate : "",
      })
        .then((res) => {
          setLoader(false);
          applyLeave({ withDeferral: true });
        })
        .catch((err) => {
          setLoader(false);
          setDeferralErrorModal(true);
          setDeferralErrorMsg(
            err.response && err.response.data && err.response.data.msg
              ? err.response.data.msg
              : "Deferral cannot be done for this student"
          );
        });
    } else {
      if (paymentMode !== "subscription") {
        toast.error("Deferral is allowed only for subscription payments", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      setLoader(false);
      setDeferralErrorModal(true);
    }
    setLoader(false);
  };

  const fetchAffectedClassesAndDemos = async () => {
    setLoader(true);
    try {
      if (moment().isAfter(moment(leaveStartDate))) {
        setLoader(false);
        return toast.error("Start date must not be in the past", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      if (
        (leaveType == 0 || leaveType == 2) &&
        moment(leaveStartDate).isAfter(moment(leaveEndDate))
      ) {
        setLoader(false);
        return toast.error("Start date must be before End date", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      const body = {
        batchId,
        studentId: students[0].studentId,
        leaveStart: leaveStartDate,
      };
      if (leaveType == 0 || leaveType == 2) {
        body.leaveEnd = leaveEndDate;
      }
      const response = await API.put("leave/student/showClasses", body);
      startDateForWhichDataFetched.current = leaveStartDate;
      endDateForWhichDataFetched.current = leaveEndDate;
      wasSingleDateLeaveForWhichDataFetched.current = leaveType;
      setClassesAffected(response.data.studentClasses.length);
      setIsCountAsCancelChanged(false);
    } catch (err) {
      if (err?.response?.data?.msg) {
        toast.error(err.response.data.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error("Something went wrong", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
    calculateCancellationAndPause();
  };

  const closeErrorModal = () => {
    setDeferralErrorModal(false);
  };
  const closeResponseModal = ({ isError }) => {
    setResponseModal(false);
    if (!isError) {
      closeModalHandler();
    }
  };

  const handleStudentCancellationCheckBox = (e, data) => {
    setCountAsCancellation(data);
    setIsCountAsCancelChanged(true);
  };

  return (
    <>
      <Dialog open={open} maxWidth="md">
        {deferPayment && deferralErrorModal && (
          <PaymentDeferralOnBreakErrorModal
            open={deferralErrorModal}
            errorMsg={deferralErrorMsg}
            closeErrorModal={closeErrorModal}
            applyLeave={applyLeave}
            paymentGateway={paymentGateway}
            paymentMode={paymentMode}
            nextPaymentDate={nextPaymentDate}
            responseModal={responseModal}
            closeResponseModal={closeResponseModal}
            responseLeaveStart={responseLeaveStart}
            responseLeaveEnd={responseLeaveEnd}
            withPaymentDeferral={deferralErrorModal}
            classesAffected={classesAffected}
          />
        )}
        {responseModal && (
          <StudentBreakReponseModal
            open={responseModal}
            withPaymentDeferral={deferPayment && !deferralErrorModal}
            closeResponseModal={closeResponseModal}
            responseLeaveStart={responseLeaveStart}
            responseLeaveEnd={responseLeaveEnd}
            paymentGateway={paymentGateway}
            newPaypalDate={newPaypalDate}
            newDate={newDate}
          />
        )}
        <DialogContent className={classes.customScroll}>
          <div className="ml-3 mr-3">
            <h3
              style={{
                textAlign: "center",
                fontSize: "20px",
                fontWeight: "600",
                fontFamily: "Roboto",
                color: "#444444",
              }}
            >
              {fromHome ? "Student Pause" : "Student Leave"}
            </h3>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                color: "#555555",
                fontSize: "16px",
                fontWeight: "400",
                fontFamily: "Roboto",
              }}
            >
              {!fromHome && (
                <p>
                  <b>Student Name: </b>
                  {students.length && students[0].studentName}
                </p>
              )}
            </div>
            <br />
            {!fromHome && (
              <RadioGroup
                value={leaveType}
                disabled={loader}
                onChange={(e) => setLeaveType(parseInt(e.target.value, 10))}
                style={{ display: "flex", flexDirection: "row" }}
              >
                <FormControlLabel
                  value={1}
                  control={<Radio color="primary" />}
                  label="Single Date"
                />
                <FormControlLabel
                  value={0}
                  control={<Radio color="primary" />}
                  label="Date Range"
                />
                <FormControlLabel
                  value={2}
                  control={<Radio color="primary" />}
                  label="On Break"
                />
              </RadioGroup>
            )}
            <div className="row mt-2 md-3">
              <Form.Group
                className={
                  leaveType === 0 || leaveType === 2 ? "col-lg-6" : "col-lg-12"
                }
              >
                {leaveType === 2 ? (
                  <Form.Label>
                    {" "}
                    Start Date<span style={{ color: "red" }}>*</span>
                  </Form.Label>
                ) : (
                  <Form.Label>
                    Leave {leaveType === 0 ? "Start" : ""} Date:
                  </Form.Label>
                )}

                <Form.Control
                  type="date"
                  defaultValue={moment(leaveStartDate).format("YYYY-MM-DD")}
                  disabled={loader}
                  onChange={(e) => dateChangeHandler(e, true)}
                />
              </Form.Group>
              {(leaveType === 0 || leaveType == 2) && (
                <Form.Group className="col-lg-6">
                  {leaveType === 2 ? (
                    <Form.Label>
                      {" "}
                      Return Date<span style={{ color: "red" }}>*</span>
                    </Form.Label>
                  ) : (
                    <Form.Label>Leave End Date:</Form.Label>
                  )}
                  <Form.Control
                    type="date"
                    defaultValue={moment(leaveEndDate).format("YYYY-MM-DD")}
                    disabled={loader}
                    onChange={(e) => dateChangeHandler(e, false)}
                  />
                </Form.Group>
              )}
            </div>
            {leaveType === 2 && (
              <div
                style={{
                  fontFamily: "Roboto",
                  fontSize: "16px",
                  fontWeight: "400",
                  color: "#555555",
                }}
              >
                <label>
                  Please enter the reason for break
                  <span style={{ color: "red" }}>*</span>{" "}
                </label>
                <textarea
                  rows="7"
                  maxLength={300}
                  style={{
                    width: "100%",
                    borderRadius: 5,
                    padding: 10,
                    border: "1px solid #7A7A7A",
                    color: "#555555",
                    outline: "none",
                    height: "100px",
                  }}
                  fullWidth
                  variant="outlined"
                  label="Please enter the reason for the break"
                  value={breakReason}
                  onChange={(e) => {
                    setBreakReason(e.target.value);
                  }}
                ></textarea>
              </div>
            )}
            {leaveType === 2 && (
              <div style={{ marginTop: "10px" }}>
                <FormControlLabel
                  label={
                    <p className={classes.formLabel}>
                      Count as Student Cancellation
                    </p>
                  }
                  control={<Checkbox color="primary" defaultChecked />}
                  onChange={(e, data) => {
                    handleStudentCancellationCheckBox(e, data);
                  }}
                  checked={countAsCancellation}
                />
                <StudentLeaveDescription
                  showIcon={false}
                  description={
                    countAsCancellation
                      ? "Classes will count as student cancellations. If cancellation limit is exceeded, any remaining classes will not be rescheduled."
                      : "All classes will be rescheduled to the end of the batch"
                  }
                  styles={{
                    fontSize: "14px",
                    fontWeight: "400",
                    color: "#555555",
                    backgroundColor: "#F0F0F0",
                    padding: "8px 12px",
                    height: countAsCancellation ? "48px" : "40px",
                  }}
                />
              </div>
            )}
            <div style={{ marginTop: "10px" }}>
              <FormControlLabel
                label={<p className={classes.formLabel}>Defer Payment</p>}
                control={<Checkbox color="primary" defaultChecked />}
                onChange={(e, data) => {
                  setDeferPayment(data);
                }}
                checked={deferPayment}
              />
            </div>
            {deferPayment && (
              <div className={classes.changeDateBox}>
                <Form.Group className="col-lg-6">
                  <Form.Label className={classes.label}>
                    {" "}
                    Change date to:
                  </Form.Label>
                  <Form.Control
                    type="date"
                    className={classes.datePicker}
                    defaultValue={moment(leaveEndDate)
                      .add(1, "day")
                      .format("DD-MM-YYYY")}
                    min={moment(leaveEndDate)
                      .add(1, "day")
                      .format("YYYY-MM-DD")}
                    // min={moment(
                    //   leaveEndDate > nextPaymentDate
                    //     ? leaveEndDate
                    //     : nextPaymentDate
                    // ).format("YYYY-MM-DD")}
                    value={newDate}
                    onChange={(e) => dateChangeHandlerForDeferPayment(e, false)}
                  />
                </Form.Group>
              </div>
            )}
            <div className={classes.availableDetailConatainer}>
              <div className={classes.availableDetail}>
                <p className={classes.label}>
                  Available pause -{" "}
                  <span className={classes.font600}>
                    {pauseAndCancellationData?.pauseLeft || 0}
                  </span>
                </p>
              </div>
              <div className={classes.availableDetail}>
                <p className={classes.label}>
                  Available cancellation -{" "}
                  <span className={classes.font600}>
                    {pauseAndCancellationData?.totalCancellationLeft || 0}
                  </span>
                </p>
              </div>
            </div>

            {showUsedPauseMessage && (
              <StudentLeaveDescription
                showIcon={true}
                icon={blue_warning}
                description={`Selected dates uses ${
                  pauseAndCancellationUsedData?.numberOfPauseDays || 0
                } pause days and ${
                  pauseAndCancellationUsedData?.totalNumberOfCancellations || 0
                } cancellations`}
                styles={{
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#287DFC",
                  backgroundColor: "#EBF3FF",
                  padding: "11px",
                  height: "58px",
                  marginTop: "24px",
                }}
              />
            )}
            {showCancelExceedMessage && (
              <StudentLeaveDescription
                showIcon={true}
                icon={orange_warning}
                description={`${
                  pauseAndCancellationUsedData?.numberOfCancellationsOverLimit ||
                  0
                } classes exceed cancellation limit. "Count as Student Cancellation" is enabled, these won't be rescheduled.`}
                styles={{
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#FB7923",
                  backgroundColor: "#FFF3EB",
                  padding: "11px",
                  height: "58px",
                  marginTop: "24px",
                }}
              />
            )}
            {showUsedPauseMessage &&
              pauseAndCancellationUsedData?.numberOfFlexForfeits > 0 && (
                <StudentLeaveDescription
                  showIcon={true}
                  icon={orange_warning}
                  description={`${pauseAndCancellationUsedData?.numberOfFlexForfeits} flex classes fall beyond the pause quota and will be forfeited (flex classes are never rescheduled to the end). They are recreated if the pause is resumed early.`}
                  styles={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#FB7923",
                    backgroundColor: "#FFF3EB",
                    padding: "11px",
                    height: "72px",
                    marginTop: "24px",
                  }}
                />
              )}
            {classesAffected !== null &&
              !hasDateChangedAfterFetching &&
              !isCountAsCancelChanged && (
                <div className={classes.classesAffectedWrapper}>
                  <div className={classes.availableDetail}>
                    <p className={classes.label}>
                      Classes Affected:{" "}
                      <span className={classes.font600}>
                        {classesAffected || 0}
                      </span>
                    </p>
                  </div>
                </div>
              )}
          </div>
          <div style={{ padding: "20px 0px 32px 0px" }}>
            {classesAffected === null ||
            hasDateChangedAfterFetching ||
            isCountAsCancelChanged ? (
              <ActionButtons
                disabledCancelBtn={loader}
                disabled={
                  loader ||
                  (leaveType == 1
                    ? !leaveStartDate
                    : !leaveStartDate || !leaveEndDate)
                }
                cancelBtnText={"Cancel"}
                proceedBtnText={
                  loader ? (
                    <Spinner animation="border" variant="light" />
                  ) : fromHome ? (
                    "Calculate"
                  ) : (
                    "Proceed"
                  )
                }
                handleCancel={closeModalHandler}
                handleProceed={fetchAffectedClassesAndDemos}
              />
            ) : (
              <ActionButtons
                disabledCancelBtn={loader}
                disabled={loader || classesAffected === null}
                cancelBtnText={"Cancel"}
                proceedBtnText={
                  loader ? (
                    <Spinner animation="border" variant="light" />
                  ) : (
                    "Submit"
                  )
                }
                handleCancel={closeModalHandler}
                handleProceed={deferPayment ? applyDeferralPayment : applyLeave}
              />
            )}
          </div>
        </DialogContent>
        {/* <DialogActions style={{ display: "flex", justifyContent: "center" }}>
          <Button
            style={{
              backgroundColor: "#FFF",
              borderBlockColor: "#FF712D",
              color: "#FF712D",
            }}
            variant="contained"
            disabled={loader}
            onClick={closeModalHandler}
          >
            Close
          </Button>
          {classesAffected === null || hasDateChangedAfterFetching ? (
            <Button
              style={{ backgroundColor: "#FF712D", color: "#FFF" }}
              variant="contained"
              disabled={
                !hasDateChangedAfterFetching ||
                loader ||
                (leaveType == 1
                  ? !leaveStartDate
                  : !leaveStartDate || !leaveEndDate)
              }
              onClick={fetchAffectedClassesAndDemos}
            >
              {loader ? (
                <Spinner animation="border" variant="light" />
              ) : fromHome ? (
                "Confirm"
              ) : (
                "Proceed"
              )}
            </Button>
          ) : (
            <Button
              style={{ backgroundColor: "#FF712D", color: "#FFFFFF" }}
              variant="contained"
              disabled={loader || classesAffected === null}
              onClick={deferPayment ? applyDeferralPayment : applyLeave}
            >
              {loader ? (
                <Spinner animation="border" variant="light" />
              ) : (
                "Submit"
              )}
            </Button>
          )}
        </DialogActions> */}
      </Dialog>
    </>
  );
};
export default StudentLeave;
